import '../../css/base.css';

const WalkHighlands = () => {

  const redirectToWalkhighlands = () => {
    window.open("https://www.walkhighlands.co.uk/kintail/");
  }
  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={redirectToWalkhighlands}>Walking Routes</a></h2>
      <p className="walk-text">Walkhighlands is a fabulous website for finding walking routes in Scotland.  It caters for low level and mountain routes
                                The link here takes you to the specific area for Kintail and Glenelg but you can explore other areas of Scotland.
                                The usual disclaimers apply that you must have the correct equipment and skills especially in winter.

      </p>       
                                    
    </div>
  );
}

export default WalkHighlands
